import React, { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBTextBody2Bold } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';

interface Props {
  title: string;
}

export function PickerSectionTitle({ title }: Props) {
  const colors = useContext(ColorThemeContext);
  return (
    <View paddingHorizontal={3} paddingTop={3}>
      <MBTextBody2Bold color={colors.foregroundActive}>{title}</MBTextBody2Bold>
    </View>
  );
}
